// import beforeEnter from './beforeEnter'
import HomePage from '@/components/routes/home'
import WeatherPage from '@/components/routes/weather'
import PoiPage from '@/components/routes/poi'
import TracksPage from '@/components/routes/tracks'
import TracksNewPage from '@/components/routes/tracksnew'
import SigninPage from '@/components/routes/signin'
import SettingsPage from '@/components/routes/settings'

export default [
  // public routes
  {
    path: '/',
    component: HomePage
  },
  {
    path: '/weather/:stationid',
    component: WeatherPage
  },
  {
    path: '/poi/:poiid',
    component: PoiPage
  },
  {
    path: '/tracks',
    component: TracksPage
  },
  {
    path: '/tracks/new',
    component: TracksNewPage
  },
  {
    path: '/signin',
    component: SigninPage
  },
  {
    path: '/settings',
    component: SettingsPage
  } // ,
  // {
  //   path: '/panel-left/',
  //   component: require('../components/ui/PanelLeft')
  // },
  // {
  //   path: '/testnavguard',
  //   component: require('../components/pages/testnavguard'),
  //   beforeEnter
  // }
]
